module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/car-bus.svg?a223bdcf7ef48550de4cf83fabc2166b";